<template>
  <div>
    <div class="mx-2">
      <span class="titulo-pagina">
        {{
          $t(
            'modulos.procedimentos_eletronicos.titulos.associar_participantes_e_setores'
          )
        }}
      </span>
      <div>
        <v-chip class="mr-1" small>
          {{
            $t(
              'modulos.procedimentos_eletronicos.tabela.procedimento_eletronico'
            )
          }}:
          {{ `${procedimento}` }}
        </v-chip>
      </div>
    </div>

    <div class="mt-9">
      <tabela-dados-procedimento
        :form="form.participantes"
        :qtd-participantes="qtdParticipantes"
      />
    </div>

    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
        <v-icon>$mdiCancel</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>
      <botao-padrao @click="salvar">
        <v-icon>$mdiContentSaveOutline</v-icon>
        {{ $t('geral.botoes.salvar') }}
      </botao-padrao>
    </div>
  </div>
</template>

<script>
import ProcedimentoEletronicoService from '@/common/services/cadastros/ProcedimentoEletronicoService';
import TabelaDadosProcedimento from './components/TabelaDadosProcedimento.vue';
import UsuarioService from '@common/services/cadastros/UsuarioService';
import { DropdownModel } from '@/common/models/geral/DropdownModel';
import { ProcedimentoEletronicoModel } from '@/common/models/cadastros/ProcedimentoEletronicoModel';

export default {
  name: 'ParticipantesSetores',
  components: {
    TabelaDadosProcedimento,
  },
  props: {
    id: { type: String, default: null },
  },
  data() {
    return {
      procedimento: null,
      qtdParticipantes: 0,
      form: new ProcedimentoEletronicoModel({}),
    };
  },
  async mounted() {
    this.$store.dispatch(
      'Layout/alterarTituloPagina',
      this.$t('modulos.procedimentos_eletronicos.titulos.listagem')
    );
    await this.buscarParticipantes();
    await this.buscar();
  },
  methods: {
    async buscar() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      await ProcedimentoEletronicoService.buscar(this.id)
        .then((res) => {
          this.$nextTick().then(() => {
            this.form = new ProcedimentoEletronicoModel(res.data);
            this.procedimento = res.data.codigo + ' - ' + res.data.nome;
          });
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    async buscarParticipantes() {
      const { id } = this.$store.getters['Autenticacao/usuario'];
      this.$store.dispatch('Layout/iniciarCarregamento');
      await UsuarioService.buscar(id)
        .then((res) => {
          const { participantes } = res.data;
          this.qtdParticipantes = participantes.length;
          this.form.participantes = participantes.map((d) => {
            return {
              participante: new DropdownModel(d.participante),
              setor: null,
            };
          });
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    async salvar() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      try {
        this.form.ehAssociarParticipantesSetores = true;
        await ProcedimentoEletronicoService.salvar(this.form);
        this.toastSucesso(
          this.$t(
            `modulos.procedimentos_eletronicos.associar_participantes_e_setores_sucesso`
          )
        );
        this.$router.push({ name: 'procedimentos-eletronicos' });
      } catch (error) {
        console.error('ERRO SALVAR', error);
        this.toastErro(
          this.$t(
            `modulos.procedimentos_eletronicos.associar_participantes_e_setores_erro`
          )
        );
      } finally {
        this.$store.dispatch('Layout/terminarCarregamento');
      }
    },
    cancelar() {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'procedimentos-eletronicos' });
      });
    },
  },
};
</script>
